import { Stack, Text, Title, useMantineTheme } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ElectionsProvider } from '@/contexts/ElectionsContext'
import { BodyStack } from '@/styled/components'

import HelpDrawer from '../HelpDrawer/HelpDrawer'
import PageSelector from '../PageSelector'
import GovernanceStepper from './GovernanceSteps/GovernanceStepper'

const CommingSoon: React.FC = () => {
  const theme = useMantineTheme()
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`)
  const { t } = useTranslation()
  return (
    <Stack style={{ flexDirection: 'column', gap: '15px', alignItems: 'center' }}>
      <Title order={isMobile ? 3 : 2}>
        {t('components.governance.commingSoon', 'OMAC Elections')}
      </Title>
      <Text>
        {t(
          'components.governance.commingSoonDescription',
          'The Open Metaverse Arts Council (OMAC) will be holding its first community seat election in Q2 2025. Stay tuned for more information.'
        )}
      </Text>
    </Stack>
  )
}

const Component: React.FC = () => {
  const { t } = useTranslation()
  const theme = useMantineTheme()
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`)
  const [council, setCouncil] = useState('OMMA')
  return (
    <ElectionsProvider>
      <BodyStack>
        <Title order={isMobile ? 3 : 2}>{t('components.elections.title', 'Elections')}</Title>
        <Stack
          style={{
            flexDirection: 'row',
            gap: '15px',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
          }}
        >
          <Stack style={{ flexDirection: 'row', gap: '15px' }}>
            <PageSelector
              text="OMMA"
              active={council === 'OMMA'}
              onClick={() => setCouncil('OMMA')}
              bold
            />
            <PageSelector
              text="OMAC"
              active={council === 'OMAC'}
              onClick={() => setCouncil('OMAC')}
              bold
            />
          </Stack>
          <HelpDrawer
            id="elections"
            extraLink={t('components.governance.moreInformation', 'More information')}
          />
        </Stack>
        {council === 'OMMA' && <GovernanceStepper />}
        {council === 'OMAC' && <CommingSoon />}
        <HelpDrawer id="elections" />
      </BodyStack>
    </ElectionsProvider>
  )
}

Component.displayName = 'Governance'

// eslint-disable-next-line import/prefer-default-export
export { Component }
